export default __webpack_public_path__ + "static/media/defaultCheckupImageLink.d75c1989.png";